<script lang="ts" setup>
import { createGAEvent, GaGeneralEvent } from '@/assets/ts/customEvent'
import { getCurrentGaPageName, getVueAssetImagePath } from '@/lib/utils'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'

defineProps<{
	data: {
		title: string
		description: string
		link: string
	}
}>()

function sendGaEvent() {
	createGAEvent(GaGeneralEvent.ButtonClick, {
		button_name: 'User Dropdown Menu Member Center',
		page_name: getCurrentGaPageName(),
	})
}
</script>

<template>
	<a
		class="mt-24px flex w-full justify-center whitespace-nowrap rounded-sm bg-o-50 px-16px py-12px tracking-wider text-n-950 hover:bg-o-100 hover:text-n-950 active:bg-o-50/75 lg:mb-8px lg:mt-0"
		:href="data.link"
		@click="sendGaEvent"
	>
		<div class="flex w-full items-center justify-between gap-8px">
			<div class="flex w-full gap-16px">
				<div class="w-[60px] shrink-0">
					<img
						class="h-[60px] w-[60px]"
						:src="getVueAssetImagePath('member-center-card-banner.svg')"
						alt="member center card banner"
						loading="lazy"
					/>
				</div>

				<div class="flex w-[176px] flex-col justify-center gap-4px">
					<div class="typography-s1-emp w-full whitespace-normal break-all">
						{{ data.title }}
					</div>
					<div class="typography-c2-reg w-full whitespace-normal break-all">
						{{ data.description }}
					</div>
				</div>
			</div>
			<BaseIcon
				name="chevron"
				class="h-16px w-16px basis-16px text-n-300"
			></BaseIcon>
		</div>
	</a>
</template>
